import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

const PresenceDetectionVideo = () => {
  const { t_ } = useSmartTranslation()
  return (
    <div className='App' style={{ textAlign: 'center' }}>
      {t_('Not available')}
    </div>
  )
}

export default PresenceDetectionVideo
